import { blockRegistry } from "@okf/ootils";

/**
 * Temporary shared list of qual block comps used by analysis modules
 * (DataPivotVisualization, OverviewDashboard, WidgetAISummary).
 *
 * Built from blockRegistry.getQualBlocks() + unregistered fallbacks.
 * Remove fallback entries as the blocks get registered.
 *
 * NOTE: This is a temporary FE-only util. Long-term: every consumer should query the
 * registry directly. Centralized here for now to avoid the duplicated array across files.
 */
export const qualComps = [
  ...blockRegistry.getQualBlocks(),
  // Unregistered blocks — remove as they get registered
  "RichTextEditor",
  "KPRichInput",
  "SummaryInput",
  "TextInput",
];
